import './Icon_Download_Excel.css';

function Icon_Download_Excel() {
  return (
    
      <div className='download-excel-container'>
          <svg viewBox="0 0 24 24" className="download-excel-svg">
            <path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>
             </svg>
      </div>
            
  );
}

export default Icon_Download_Excel;
